module.exports = __webpack_public_path__ + "img/empty-doc.0b2f76a5.svg";